import { Link } from 'react-router-dom';
import { mockArticles } from '@/mocks/articles';

export default function LatestArticles() {
  const articles = mockArticles.slice(0, 3);

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-6 mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-2" style={{ fontFamily: "var(--font-heading)" }}>
              最新资讯
            </h2>
            <p className="text-sm text-foreground-500">
              了解蘑菇视频最新动态与观影指南
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group rounded-xl overflow-hidden bg-background-100 hover:bg-background-200/70 transition-all duration-300"
            >
              <div className="w-full aspect-video overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={`${article.title} - 蘑菇视频官网`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className="px-2.5 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-xs font-medium">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-500">{article.date}</span>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                  {article.summary}
                </p>
                <div className="flex items-center gap-3 mt-4 text-xs text-foreground-500">
                  <span><i className="ri-user-line mr-1"></i>{article.author}</span>
                  <span><i className="ri-eye-line mr-1"></i>{article.views}阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}